import Theme, { StyleProp } from '@adsk/alloy-react-theme';

export const imageStyle = {
  height: '120px',
};

export const bodyStyle = {
  padding: '23px 32px',
};

export const imageTextLinkStyle = {
  ...Theme.typography.bodySmall,
};

export const footerHelpLinkStyle: StyleProp = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};
